var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bank 5 logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 20C34.9998 28.283 28.2828 35 19.9998 35C11.7168 35 4.99976 28.283 4.99976 20C4.99976 11.717 11.7168 5 19.9998 5C28.2828 5 34.9998 11.717 34.9998 20Z",
    fill: "#42D778"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7496 20.0001C26.7496 23.7291 23.7286 26.7501 19.9996 26.7501C16.2706 26.7501 13.2496 23.7291 13.2496 20.0001C13.2496 16.2711 16.2706 13.2501 19.9996 13.2501C23.7286 13.2501 26.7496 16.2711 26.7496 20.0001Z",
    fill: "#0F62FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank5);
export default __webpack_public_path__ + "static/media/bank5.4ac2f958af93b53f98d605163e553a4c.svg";
export { ForwardRef as ReactComponent };